import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import ArticlesDashboard from './pages/ArticlesDashboard';

const Articles = () => {
    const [searchPanelOpen, setSearchPanelOpen] = useState(false);

    return (
        <div className="container-fluid px-3 px-lg-4">
            <div className="pagetitle d-flex justify-content-between align-items-center">
                <h1>
                    <i className="bi bi-file-medical"></i> Articles
                </h1>
                <div>
                    <Link to="/articles/new" className="btn btn-sm btn-outline-primary me-2">
                        <i className="bi bi-plus"></i> Draft New Article
                    </Link>
                    <Link to="/articles/category" className="btn btn-sm btn-outline-secondary">
                        <i className="bi bi-gear"></i> Manage Categories
                    </Link>
                </div>
            </div>
            <Card className="card-padding shadow-sm border-0">
                <Card.Body className="p-3">
                    <ArticlesDashboard
                        searchPanelOpen={searchPanelOpen}
                        onSearchPanelToggle={() => setSearchPanelOpen((open) => !open)}
                    />
                </Card.Body>
            </Card>
        </div>
    );
};

export default Articles;
